import React from 'react';
import { Hero } from '../components/landing/Hero';
import { WhatYouGet } from '../components/landing/WhatYouGet';
import { Curriculum } from '../components/landing/Curriculum';
import { Bonuses } from '../components/landing/Bonuses';
import { SpiritualBonus } from '../components/landing/SpiritualBonus';
import { Testimonials } from '../components/landing/Testimonials';
import { ValueStack } from '../components/landing/ValueStack';
import { WhoThisIsFor } from '../components/landing/WhoThisIsFor';
import { FinalCTA } from '../components/landing/FinalCTA';
import { StickyHeader } from '../components/landing/StickyHeader';
import { StickyCTA } from '../components/landing/StickyCTA';
import { Footer } from '../components/landing/Footer';
import { WhatsAppButton } from '../components/landing/WhatsAppButton';
export function BlackFridayLanding() {
  return <div className="min-h-screen bg-white" data-id="element-382">
      <StickyHeader data-id="element-383" />
      <Hero data-id="element-384" />
      <WhatYouGet data-id="element-385" />
      <Curriculum data-id="element-386" />
      <Bonuses data-id="element-387" />
      <SpiritualBonus data-id="element-388" />
      <Testimonials data-id="element-389" />
      <ValueStack data-id="element-390" />
      <WhoThisIsFor data-id="element-391" />
      <FinalCTA data-id="element-392" />
      <StickyCTA data-id="element-393" />
      <Footer data-id="element-394" />
      <WhatsAppButton data-id="element-395" />
    </div>;
}